module.exports = ".radio-group-label{\n  margin-top: 5px;\n}\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/shared/components/owner-details/owner-details.component.css
// module id = ./src/app/shared/components/owner-details/owner-details.component.css
// module chunks = main